import React from 'react';
import logoUrl from './easydebt-logo.svg';

export const Logo = ({ width, height = 48, title = 'EasyDebt' }) => (
  <img
    src={logoUrl}
    alt={title}
    style={{
      display: 'block',
      height,
      width: width || 'auto',
      objectFit: 'contain',
    }}
  />
);
